import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../components/LanguageContext';
import './HeroSection.css';

function HeroSection() {
  const { language } = useLanguage();

  const content = {
    en: {
      subtitle: 'Professional Cleaning Services',
      title: 'Transform Your Space Into a Sparkling Haven',
      description: 'We deliver exceptional cleaning services with precision and care. Experience the difference of true professional cleaning.',
      services: [
        'Deep Cleaning & Sanitization',
        'Premium Upholstery Care',
        'Facade & Glass Cleaning',
        'Fragrance & Freshness'
      ],
      cta: 'Get Started'
    },
    ar: {
      subtitle: 'خدمات تنظيف احترافية',
      title: 'حوّل مساحتك إلى واحة نظافة وبريق',
      description: 'نقدم خدمات تنظيف استثنائية بدقة وعناية. اختبر الفرق مع التنظيف الاحترافي الحقيقي.',
      services: [
        'تنظيف عميق وتعقيم شامل',
        'عناية فاخرة بالمفروشات',
        'تنظيف الواجهات والزجاج',
        'تعطير ونضارة دائمة'
      ],
      cta: 'ابدأ الآن'
    }
  };

  const { subtitle, title, description, services, cta } = content[language];

  return (
    <section id="intro" className={`hero ${language === 'ar' ? 'rtl' : ''}`}>
      {/* Background */}
      <div className="hero-bg">
        <div className="hero-gradient" />
        <div className="hero-pattern" />
      </div>

      {/* Content */}
      <div className="hero-container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Subtitle */}
          <motion.span 
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            ✦ {subtitle}
          </motion.span>

          {/* Title */}
          <motion.h1 
            className="hero-title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.7 }}
          >
            {title}
          </motion.h1>

          {/* Description */}
          <motion.p 
            className="hero-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {description}
          </motion.p>

          {/* Services List */}
          <motion.ul 
            className="hero-services"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            {services.map((service, i) => (
              <motion.li 
                key={i}
                initial={{ opacity: 0, x: language === 'ar' ? 20 : -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6 + i * 0.1 }}
              >
                <span className="service-dot" />
                {service}
              </motion.li>
            ))}
          </motion.ul>

          {/* CTA */}
          <motion.a
            href="https://wa.me/+966560308877"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-cta"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.6 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <i className="fab fa-whatsapp" />
            {cta}
          </motion.a>
        </motion.div>

        {/* Decorative Image/Element */}
        <motion.div 
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <div className="visual-card">
            <img 
              src={require("../Images/Icon.jpeg")} 
              alt="Sparkles Laundry"
              className="visual-logo"
            />
            <div className="visual-glow" />
          </div>
        </motion.div>
      </div>

    </section>
  );
}

export default HeroSection;
